import { NotificationType } from '@routific/hive';
import i18n from '../../i18n';
import formatDisplayDate from '../../helpers/formatDisplayDate';

export const moveRouteSuccessNotification = (
  projectId: string,
  count: number,
  onClick?: () => void,
  targetDate?: string,
  selectedDate?: string,
) => {
  let linkMessage: string | undefined;
  const message = i18n.t('notifications:moveRoute.success.message', { count });

  if (targetDate && onClick && selectedDate !== targetDate) {
    const formattedDate = formatDisplayDate(targetDate, true);
    linkMessage = i18n.t('notifications:moveRoute.success.linkMessage', { count, date: formattedDate });
  }

  return {
    type: NotificationType.SUCCESS,
    id: `${projectId}-move-route-success`,
    message,
    linkOnClick: onClick,
    linkMessage,
    dataCy: 'move-route-success-notification',
  };
};

export const moveRouteFailureNotification = (projectId: string, error?: string, count?: number) => ({
  type: NotificationType.ERROR,
  id: `${projectId}-move-route-failed`,
  message: error || i18n.t('notifications:moveRoute.failure.message', { count: count ?? 1 }),
  dataCy: 'move-route-failure-notification',
});
